import styled from 'styled-components';

import { theme, tokens } from '@mindtickle/styles';

import Dropdown from '@mindtickle/dropdown';

import Icon from '@mindtickle/icon';

export const StyledHelpActionIcon = styled(Icon)`
  font-size: 12px;
  margin-left: 8px;
`;

export const menuDropdownOverlayStyle = {
  width: '235px',
  borderRadius: '0 0 4px 4px',
  background: tokens.bgTokens.COLOR_BG_DEFAULT,
};

export const StyledDropdown = styled(Dropdown)`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .mtdls-dropdown {
    border: 1px solid ${tokens.borderTokens.COLOR_BORDER_SECONDARY};
    border-radius: 0 0 4px 4px;

    .mtdls-dropdown-menu {
      border: none;
      box-shadow: ${theme.boxShadow.LEVEL2};
    }
  }
`;

export const StyledHelpTriggerWrapper = styled.div<{ $isDropdownOpen: boolean }>`
  width: 32px;
  padding: 6px;
  height: 32px;
  display: flex;
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  background-color: ${({ $isDropdownOpen }) =>
    !$isDropdownOpen ? tokens.bgTokens.COLOR_BG_DEFAULT : tokens.bgTokens.COLOR_BG_BRAND};

  .help-trigger-icon {
    font-size: 20px;
    line-height: 20px;
    color: ${({ $isDropdownOpen }) =>
      !$isDropdownOpen
        ? tokens.iconTokens.COLOR_ICON_DEFAULT
        : tokens.iconTokens.COLOR_ICON_ACCENT};
  }

  &:hover {
    background-color: ${({ $isDropdownOpen }) =>
      $isDropdownOpen ? tokens.bgTokens.COLOR_BG_BRAND : tokens.bgTokens.COLOR_BG_TERTIARY};
  }
`;
